export const specializations = [
  {
    title: 'Бухгалтер коммерческая организация',
  },
  {
    title: 'Бухгалтер бюджетная организация',
  },
  {
    title: 'Юрист',
  },
  {
    title: 'Кадровик',
  },
  {
    title: 'Специалист по охране труда',
  },
  {
    title: 'Руководитель',
  },
  {
    title: 'Специалист по закупкам',
  },
  {
    title: 'IT-специалист',
  },
];
